import cx from 'classnames'
import { track } from '@tldraw/tldraw'
import Styles from './ShapeOverlay.module.scss'
import { ShapeOverlayProps } from './Types'
import { observer } from 'mobx-react-lite'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { pageToViewport } from '../../helpers'

const ShapeOverlay = track(
  observer(({ shape, children, className }: ShapeOverlayProps) => {
    const editor = useEditor()

    const pageBounds = editor.getShapePageBounds(shape)
    const shapeDimensions = editor.getShapeUtil(shape).getGeometry(shape).bounds
    if (!pageBounds) return null

    const pageCoordinates = pageToViewport(editor, pageBounds.point)

    return (
      <div
        className={cx(Styles.shapeOverlay, className)}
        style={{
          top: pageCoordinates.y,
          left: pageCoordinates.x,
          width: shapeDimensions.w,
          height: shapeDimensions.h,
        }}
      >
        {children}
      </div>
    )
  }),
)

export { ShapeOverlay }
